let aceFallbackPositions = {
    'r1': {
        'slot': '/22591568131/vivaforum_rx/r1',
        'sizes': [[300, 250], [336, 280]]
    },
    'r2': {
        'slot': '/22591568131/vivaforum_rx/r2',
        'sizes': [[300, 250], [336, 280]]
    },
    'r3': {
        'slot': '/22591568131/vivaforum_rx/r3',
        'sizes': [[300, 250], [336, 280]]
    },
    'h1': {
        'slot': '/22591568131/vivaforum_h1',
        'sizes': [[728, 90], [970, 90], [970, 250]]
    },
    'h2': {
        'slot': '/22591568131/vivaforum_h2',
        'sizes': [[728, 90], [970, 250]]
    },
    'h3': {
        'slot': '/22591568131/vivaforum_h3',
        'sizes': [[728, 90], [970, 250]]
    },
    'h0': {
        'slot': '/22591568131/vivaforum_h0',
        'sizes': [[728, 90], [970, 90], [970, 250]]
    },
    'r1': {
        'slot': '/22591568131/vivaforum_rx/r1',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r2': {
        'slot': '/22591568131/vivaforum_rx/r2',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r3': {
        'slot': '/22591568131/vivaforum_rx/r3',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r4': {
        'slot': '/22591568131/vivaforum_rx/r4',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r5': {
        'slot': '/22591568131/vivaforum_rx/r5',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r6': {
        'slot': '/22591568131/vivaforum_rx/r6',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r7': {
        'slot': '/22591568131/vivaforum_rx/r7',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'r8': {
        'slot': '/22591568131/vivaforum_rx/r8',
        'sizes': [[300, 250], [336, 280], [300, 600]]
    },
    'v1': {
        'slot': '/22591568131/vivaforum_v1',
        'sizes': [[120, 600], [160, 600]]
    },
    'v2': {
        'slot': '/22591568131/vivaforum_v2',
        'sizes': [[120, 600], [160, 600]]
    },
}


let aceMutationOrig = [];
let aceRegisteredMisses = [];

const aceMutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {

        const {target} = mutation;
        if (target) {
            const {dataset, classList} = target;

            if (
                typeof dataset.advertOrigId !== 'undefined'
                && (typeof dataset.advertSlotEmpty !== 'undefined' || classList.contains('noad'))
                && aceMutationOrig[dataset.advertOrigId]
                && typeof aceRegisteredMisses[dataset.advertOrigId] === 'undefined'
            ) {
                // unobserve to avoid dupes; unfortunately unobserve is not available as a function yet
                aceRegisteredMisses[dataset.advertOrigId] = true;

                // define and trigger alternative AD
                if (window.googletag && aceFallbackPositions[aceMutationOrig[dataset.advertOrigId].aceslot]) {
                    window.googletag.cmd.push(function () {
                        mutation.target.id = dataset.advertOrigId;
                        window.googletag.defineSlot(
                            aceFallbackPositions[aceMutationOrig[dataset.advertOrigId].aceslot].slot,
                            aceFallbackPositions[aceMutationOrig[dataset.advertOrigId].aceslot].sizes,
                            mutation.target.id
                        ).addService(googletag.pubads());
                        window.googletag.enableServices();
                    });
                    window.googletag.cmd.push(function () {
                        googletag.display(mutation.target.id);
                    });
                }
                // track missed opportunity
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'ace',
                        value: 'miss',
                        slot: aceMutationOrig[dataset.advertOrigId].aceslot
                    });
                }
            }
        }
    });
});


window.handleAceSlots = () => {
    if (!window.loadAdvertSlot) {
        return;
    }

    // handle ace slots
    let rxSlotElements = document.querySelectorAll(".banner-target-rx:not(.handled)");
    rxSlotElements.forEach(div => {

        div.classList.add("handled");
        aceMutationObserver.observe(div, {attributes: true, attributeFilter: ["class", "data-advert-slot-empty"]});
        aceMutationOrig[div.id] = div.dataset;
        if (window.loadAdvertSlot && div.dataset.aceslot) {

            let ace_observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        window.loadAdvertSlot(entry.target.dataset.aceslot, entry.target.id);
                        // track opportunity
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'ace',
                                value: 'opportunity',
                                slot: entry.target.dataset.aceslot
                            });
                        }
                        observer.disconnect();
                    }
                });
            }, {
                root: null,
                rootMargin: '0px 0px 300px 0px',
                threshold: 0.1
            });
            ace_observer.observe(div);
        }
    });
}

window.addEventListener('DOMContentLoaded', (event) => {

    if (typeof window.handleAceSlots !== 'undefined') {
        window.handleAceSlots();
    }

});
